import { useCallback } from 'react'

import { IMAGE_SIZES } from '../constants/image-sizes'
import useDimensions from './useDimensions'

const useImageSize = () => {
  const { isDesktop } = useDimensions()

  const imageSize = useCallback((imageKey: keyof typeof IMAGE_SIZES) => {
    return IMAGE_SIZES[imageKey][isDesktop ? 'big' : 'small']
  }, [])

  return imageSize
}

export default useImageSize
